import { createApiHandler } from './handler';

const users = {
  apiClient: null,
  path: '/franchises/users',

  setClient(apiClient) {
    this.apiClient = apiClient;
    this.initApiHandler();
  },

  initApiHandler() {
    Object.assign(this, createApiHandler(this.apiClient, this.path));
  },
};

export default users;
